function Contact() {
  return (
    <section className="contact-band" id="contact">
      <div className="wrap contact-inner">
        <h2>Let’s build greater resilience together.</h2>
        <a className="btn" href="mailto:anuraag@willmarsre.com">Speak with Anuraag Kaul</a>
      </div>
    </section>
  )
}

export default Contact
